<section>
  <label [for]="_id()">
    @if (isUploading()) {
      <sb-loading-state></sb-loading-state>
    } @else {
      <b>
        {{ 'Drag and drop a file here or' | translate }} <span>{{ 'browse files' | translate }}</span>
      </b>
      <ng-content></ng-content>
      <input
        [id]="_id()"
        type="file"
        [accept]="allowedTypes()"
        [multiple]="multiple()"
        (change)="handleFileInput($event)"
      />
    }
  </label>
</section>
